import { useEffect, useState } from 'react';

import type { UserMembership } from '@/src/api/authApi';
import membershipsApi from '@/src/api/membershipsApi';
import { useSessionUser } from '@/src/lib/sessionStore';

/**
 * The signed-in user's `GET /me/memberships`, for the upsell rules — `null`
 * until it lands. Signed out there's no history to know, so that's `[]` with no
 * fetch, and keyed by user so a login mid-screen fetches for whoever arrived.
 */
export function usePastMemberships(): UserMembership[] | null {
  const userId = useSessionUser()?.id ?? null;
  const [fetched, setFetched] = useState<{
    userId: string;
    memberships: UserMembership[];
  } | null>(null);

  useEffect(() => {
    if (!userId) return;
    let live = true;
    membershipsApi
      .listMyMemberships()
      // Fails open: a history we couldn't load blocks nothing, and
      // `hasUsedUpTrialPass` still closes the trial for anyone who took it.
      .catch(() => [])
      .then((memberships) => {
        if (live) setFetched({ userId, memberships });
      });
    return () => {
      live = false;
    };
  }, [userId]);

  if (!userId) return [];
  return fetched?.userId === userId ? fetched.memberships : null;
}
